import { Injectable } from '@angular/core';
import { Stripe, loadStripe } from '@stripe/stripe-js';
import { environment } from '../../environments/environment';

/**
 * Stripe.js for one connected account. A membership's cards live on its location's connected
 * account, so a card added for it must be set up there; the platform-account StripeService
 * cannot do that.
 */
@Injectable({ providedIn: 'root' })
export class ConnectedAccountStripeService {
  load(stripeAccountId: string): Promise<Stripe | null> {
    return loadStripe(environment.stripePublicKey, { stripeAccount: stripeAccountId });
  }
}
